import { render, staticRenderFns } from "./ModalStage.vue?vue&type=template&id=1ea838c0&"
import script from "./ModalStage.vue?vue&type=script&lang=js&"
export * from "./ModalStage.vue?vue&type=script&lang=js&"
import style0 from "./ModalStage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports